import React from 'react';
import SearchResultsHeader from './SearchResultsHeader';
import PropertyGrid from './PropertyGrid';
import MobilePropertyGrid from './MobilePropertyGrid';
import Pagination from './Pagination';
import CTASection from './CTASection';
import EmptyState from './EmptyState';
import DublinCommuterWidget from './DublinCommuterWidget';
import { Listing } from '../../../components/property/property-card/PropertyCardTypes';
import { SearchParams } from '../BrowseListingsPage';

interface SearchResultsContentProps {
  listings: Listing[];
  totalListings: number;
  searchParams: SearchParams;
  sortOption: string;
  currentPage: number;
  totalPages: number;
  isLoading: boolean;
  bookmarkedListings: number[];
  isMobileCompactView?: boolean;
  showDublinCommuterWidget?: boolean;
  onSort: (option: string) => void;
  onPageChange: (page: number) => void;
  onBookmarkToggle: (id: number) => void;
  onShare: (listing: Listing) => void;
  onListingView: (listing: Listing) => void;
}

const SearchResultsContent: React.FC<SearchResultsContentProps> = ({
  listings,
  totalListings,
  searchParams,
  sortOption,
  currentPage,
  totalPages,
  isLoading,
  bookmarkedListings,
  isMobileCompactView = false,
  showDublinCommuterWidget = false,
  onSort,
  onPageChange,
  onBookmarkToggle,
  onShare,
  onListingView
}) => {
  if (listings.length === 0) {
    return <EmptyState />;
  }

  return (
    <>
      <SearchResultsHeader
        totalListings={totalListings}
        searchParams={searchParams}
        sortOption={sortOption}
        onSort={onSort}
      />

      {showDublinCommuterWidget && !isMobileCompactView ? <DublinCommuterWidget /> : null}

      {isMobileCompactView ? (
        <MobilePropertyGrid
          listings={listings}
          bookmarkedListings={bookmarkedListings}
          onBookmarkToggle={onBookmarkToggle}
          onListingView={onListingView}
        />
      ) : (
        <PropertyGrid
          listings={listings}
          bookmarkedListings={bookmarkedListings}
          onBookmarkToggle={onBookmarkToggle}
          onShare={onShare}
          onListingView={onListingView}
        />
      )}

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        isLoading={isLoading}
        onPageChange={onPageChange}
      />

      <CTASection />
    </>
  );
};

export default SearchResultsContent;
